import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';

// Redux
import { NgRedux } from '@angular-redux/store';
import { IAppState } from '../../core/store/store';

// Foreign feature
import { menuWantProtectedRoute } from '../../menu/store/actions';

@Injectable()
export class UserRouteGuard implements CanActivate {

  constructor(
    private _store: NgRedux<IAppState>,
    private _router: Router
  ) {}

   /**
    * canActivate
    * @param route ActivatedRouteSnapshot
    * @param state RouterStateSnapshot
    * @returns boolean
    */
   public canActivate(
      route: ActivatedRouteSnapshot,
      state: RouterStateSnapshot
   ): boolean {
      if (this._store.getState().userState.currentUser) {
      if (this._store.getState().menuState.wantProtectedRoute) {
         this._store.dispatch(menuWantProtectedRoute(null));
      }
      return true;
      }
      // not logged in
      this._store.dispatch(menuWantProtectedRoute(state.url));
      this._router.navigate(['/signin']);
      return false;
   }

}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/user/service/user.routeguard.ts